export default "__VITE_ASSET__CZLHZU9W__"